import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineShoppingCart } from 'react-icons/hi';
import { IOrderProduct } from '../../../../types/OrderProduct';
import { PublicProduct } from '../../../../api/publicOrder';
import CartDropdown from './CartDropdown';

interface CartHeaderProps {
    selectedProducts: IOrderProduct[];
    products: PublicProduct[];
    onProceedToDetails: () => void;
    canProceedToDetails: boolean;
    currentStep: number;
}

const CartHeader: React.FC<CartHeaderProps> = ({
    selectedProducts,
    products,
    onProceedToDetails,
    canProceedToDetails,
    currentStep
}) => {
    const { t } = useTranslation(['order_form']);
    const [isCartOpen, setIsCartOpen] = useState(false);

    const handleProceedFromCart = () => {
        setIsCartOpen(false);
        onProceedToDetails();
    };

    return (
        <div className="relative">
            <button
                onClick={() => setIsCartOpen(!isCartOpen)}
                className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white border border-gray-200 text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800 transition-all duration-200 shadow-sm relative"
                title={t('public_form.cart.view_cart')}
            >
                <HiOutlineShoppingCart className="h-5 w-5" />
                {selectedProducts.length > 0 && (
                    <span className="absolute -top-2 -right-2 inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white public-form-primary-bg rounded-full">
                        {selectedProducts.length}
                    </span>
                )}
            </button>

            {isCartOpen && (
                <CartDropdown
                    selectedProducts={selectedProducts}
                    products={products}
                    onClose={() => setIsCartOpen(false)}
                    onProceedToDetails={handleProceedFromCart}
                    canProceedToDetails={canProceedToDetails}
                    currentStep={currentStep}
                />
            )}
        </div>
    );
};

export default CartHeader; 